import { useState, useEffect } from "react";
import { useI18n } from "@/lib/i18n";

export default function AgeGate() {
  const [accepted, setAccepted] = useState(true);
  const { t, lang, toggle } = useI18n();

  useEffect(() => {
    const ok = localStorage.getItem("beb_age_ok");
    if (!ok) setAccepted(false);
  }, []);

  const accept = () => {
    localStorage.setItem("beb_age_ok", "1");
    setAccepted(true);
  };

  const decline = () => {
    window.location.href = "https://www.google.com";
  };

  if (accepted) return null;

  return (
    <div
      data-testid="age-gate"
      className="fixed inset-0 z-[100] flex items-center justify-center"
      style={{
        background:
          "linear-gradient(rgba(0,0,0,0.78), rgba(0,0,0,0.92)), url('https://static.prod-images.emergentagent.com/jobs/80c4a7d5-1156-4a15-9444-cb1ba4c521cc/images/fd3f189e02be90dab2099b4f74b6d646fc6990bbf6b0c033b24a4eec52d52c27.png') center/cover no-repeat",
      }}
    >
      <button
        data-testid="age-gate-lang"
        onClick={toggle}
        className="absolute top-6 right-6 text-xs uppercase tracking-[0.3em] text-white/70 border border-white/15 px-3 py-2 hover:border-[var(--gold)]/60"
      >
        {lang === "en" ? "EN / ΕΛ" : "ΕΛ / EN"}
      </button>
      <div className="grain absolute inset-0 pointer-events-none" />
      <div className="relative max-w-2xl mx-auto text-center px-8 fade-up">
        <div className="label-luxury mb-8">{t("ag_subtitle")}</div>
        <h1 className="font-serif-display text-4xl md:text-6xl font-semibold tracking-[0.15em] uppercase leading-[1.1] mb-3 gold-text">
          Bilion Euro
        </h1>
        <h1 className="font-serif-display text-4xl md:text-6xl font-semibold tracking-[0.15em] uppercase leading-[1.1] mb-4 gold-text">
          Babies
        </h1>
        <div className="label-pink mb-10 text-[0.6rem]">Luxury Beyond Imagination</div>
        <div className="divider-rose mb-10">
          <span className="text-xs tracking-[0.4em]">◆</span>
        </div>
        <p className="text-white/70 text-sm md:text-base leading-relaxed mb-3 max-w-md mx-auto">
          {t("ag_text")}
        </p>
        <p className="label-luxury mb-12">{t("ag_confirm")}</p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            data-testid="age-gate-accept"
            onClick={accept}
            className="btn-gold btn-gold-solid w-full sm:w-auto"
          >
            {t("ag_enter")}
          </button>
          <button
            data-testid="age-gate-decline"
            onClick={decline}
            className="btn-gold btn-ghost w-full sm:w-auto"
          >
            {t("ag_exit")}
          </button>
        </div>

        <p className="text-white/40 text-xs mt-12 tracking-wider">
          {t("ag_disclaimer")}
        </p>
      </div>
    </div>
  );
}
